import { Grid2 } from "@mui/material";
import { viewmodeUI } from "../../../../../App";
import useUIBp from "../../../../../Hooks/useUIBoilerplate";
import useVH from "../../../../../Hooks/useVH";
import { UIactions } from "../../../../../store/slices/UI";
import FilterField from "../../../GeneralPurpose/FilterField";
import { defaultFilter } from "../../../GeneralPurpose/genericIDs";
import AdvancedSearchButton from "./AdvancedSearchButton";
import RecursiveSwitch from "./Recursive";

const UIText = {
  "es-CL": { placeholder: "Filtrar" },
  "en-US": { placeholder: "Filter" },
};

const FilterPlusActions = ({ advancedFilter, advancedFilterModal, children, plusActionsGrid, noRecursive, filterSize = "auto" }) => {
  const { dispatch,UI } = useUIBp();
  const viewmode = UI[viewmodeUI] ?? "desktop";
  const vh = useVH(8);
  const vh2 = useVH(10);

  const  handleChange = (e) => {
    const value = e.target.value;
    dispatch(UIactions.setValue({ id:defaultFilter, value }));
    // dispatch(UIactions.clear(defaultPagination));
  }

  return (
    <Grid2
      container
      {...{
        height: viewmode === "desktop" ? vh : vh2,
        alignItems: "center",
        size: 12,
        columnSpacing: 2,
        rowGap: 1,
        paddingTop: "1vh",
        paddingLeft: 2,
        paddingRight: 2,
      }}
    >
      <Grid2 container size={plusActionsGrid}>
        <Grid2 container {...{ size: filterSize }}>
          <FilterField fullWidth {...{ onChange:handleChange, UIText, size: "grow" }} />
          {advancedFilter?<AdvancedSearchButton modalType={advancedFilterModal} />:null}
        </Grid2>
        {noRecursive ? null : <RecursiveSwitch {...{ size: "auto" }} />}
      </Grid2>
      {children}
    </Grid2>
  );
};

export default FilterPlusActions;
